import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  GetDefaultSupplierAllocationResponse,
  PostDefaultSupplierAllocationRequest,
  PutDefaultSupplierAllocationRequest,
  PostDefaultSupplierAllocationResponse,
  PutDefaultSupplierAllocationResponse,
} from './default-supplier-allocations.interface';

@Injectable({
  providedIn: 'root',
})
export class DefaultSupplierAllocationsService {
  private readonly _baseUrl = environment.pureSpectrum.url;

  constructor(private _http: HttpClient) {}

  getDefaultSupplierAllocation(locale: string) {
    return this._http.get<GetDefaultSupplierAllocationResponse>(
      `${this._baseUrl}/default-supplier-allocation/${locale}`
    );
  }

  createDefaultSupplierAllocation(
    payload: PostDefaultSupplierAllocationRequest
  ) {
    return this._http.post<PostDefaultSupplierAllocationResponse>(
      `${this._baseUrl}/default-supplier-allocation`,
      payload
    );
  }

  updateDefaultSupplierAllocation(
    id: number,
    payload: PutDefaultSupplierAllocationRequest
  ) {
    return this._http.put<PutDefaultSupplierAllocationResponse>(
      `${this._baseUrl}/default-supplier-allocation/${id}`,
      payload
    );
  }
}
